const trackEvent = ({name, payload}) => {
  window.analytics?.track(name, payload);
}

export { trackEvent }
